import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    ReferenceInput,
    SearchInput,
    SelectInput,
    EditButton,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import PackingShow from './PackingShow'
import jwt_decode from 'jwt-decode'
import BoolNumField from '../controls/PureBoolNumField'
import ErrorBoundary from '../ErrorBoundary';

const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

const Editable = ({record}) => {
    console.log(record.editable);
        return <EditButton  record={record} label='Update'/>;
    //return record && record.editable > 0 ? <EditButton  record={record} label='Update'/> : '';
}


export const PackingFilter = props => (
    <Filter {...props}>
        <SearchInput source="case_no" alwaysOn  placeholder='Case Number'/>
        <DateInput source="bleed_date" />
        <TextInput source="ucn" lable="Unit Control Number" />
        <TextInput source="ssn" lable="SSN" />
        <TextInput source="name" lable="Name" />
    </Filter>
);

export const PackingList = props => (
    <ErrorBoundary>  
    <List 
        {...props}
        filters={<PackingFilter />}
        perPage={20}
        sort={{ field: 'bleed_date', order: 'DESC' }}
        bulkActionButtons ={false}
        
        >
        <Datagrid    expand={<PackingShow />} >
            <TextField source="case_no" label="Case#" />     
            <TextField source="ucn" label="Unit Control#" />
            <TextField source="ssn" label="SSN"/>
            <TextField source="name" label="Name"/>
            <DateField source="dob" label="DOB"  locales="en-us"/>
            <DateField source="bleed_date" label="Bleed date" locales="en-us"/>
            <BoolNumField source="ready_to_ship"  label="Ready to Ship" /> 
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 2  && <Editable />}
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default PackingList